export default __webpack_public_path__ + "static/media/schwee.8d7032da.png";